// 岗位管理
import http from '../httpConfig'

const table = "mrbase_sys_job_posts"


// 岗位列表查询接口
export const getPostList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/post/list-post/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//岗位详情
export const getDetailsPost = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/post/find-post/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//  岗位新增
export const addPost = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/post/add-post/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//岗位修改
export const updatePost = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/post/update-post/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//岗位删除
export const deletePost = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/post/delete-post/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
